import {Component, OnInit, Inject, AfterViewInit, ViewChild} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators, UntypedFormControl} from '@angular/forms';
import {UsersService, IRegion2} from '../users.service';
import {debounceTime} from 'rxjs/operators';
import {HttpErrorResponse} from '@angular/common/http';
import {IRoleEx} from '../../roles/roles-list/roles-list.component';
import {IDepartment, ICompany} from '../../roles/roles.service';
import {MatSelect} from '@angular/material/select';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'app-users-form',
  templateUrl: './users-form.component.html',
  styleUrls: ['./users-form.component.scss']
})
export class UsersFormComponent implements OnInit, AfterViewInit {

  @ViewChild('departmentSelect', {static: false}) departmentSelect: MatSelect;
  dataGroup: UntypedFormGroup;
  title = '';
  groupValuesChanges = false;
  rolesValuesChanges = false;
  roles: IRoleEx[] = [];
  emailPattern = '^[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,4}$';
  regions: IRegion2[] = [];
  selectedRoles: IRoleEx[] = [];
  companies: ICompany[] = [];
  departments: IDepartment[] = [];
  loadData = false;
  ngAfterFlag = false;

  hidePassword = true;
  hideConfirmPassword = true;

  constructor(
    public dialogRef: MatDialogRef<UsersFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: UntypedFormBuilder,
    private snackBar: MatSnackBar,
    protected service: UsersService) {
    this.regions = data.regionList;
  }

  ngOnInit() {
    this.getRegions();
  }

  getRegions() {
    this.loadData = true;
    this.service.getUserRegions(this.data.data.id).subscribe(res => {
      this.data.data.mioID = res.map(r => r.id);
      this.dataGroup = this.createForm();
      if (this.data.type === 'edit') {
        this.title = 'Редактировать';
        this.roles = this.data.roles;
        this.departments = this.data.departments;
      } else if (this.data.type === 'create') {
        this.title = 'Создать нового пользователя';
        this.roles = this.data.roles;
        this.companies = this.data.companies;
      }
      this.selectedRoles = this.getSelectedRoles(this.dataGroup.value.roles, this.roles);
      this.rolesValuesChanges = this.selectedRoles.length > 0;
      this.loadData = false;
      this.ngAfterFlag = true;
    });
  }

  ngAfterViewInit() {
    if (this.ngAfterFlag) {
      this.dataGroup.valueChanges.pipe(
        debounceTime(500)
      ).subscribe(data => {
        if (data) {
          if (data.roles.length > 0) {
            this.rolesValuesChanges = true;
            this.selectedRoles = this.getSelectedRoles(data.roles, this.roles);
          } else {
            this.rolesValuesChanges = false;
          }
          this.groupValuesChanges = true;
        }
      });
    }
  }

  getSelectedRoles(roles: [], allRoles: IRoleEx[]) {
    const res: IRoleEx[] = [];
    for (let i = 0; i < roles.length; i++) {
      const fRole = allRoles.find(f => f.name === roles[i]);
      if (fRole) {
        res.push(fRole);
      }
    }
    return res;
  }

  createForm() {
    const group = this.fb.group({});
    // tslint:disable-next-line:forin
    for (const k in this.data.data) {
      const control = this.fb.control(
        this.data.data[k],
      );
      group.addControl(k, control);
    }
    if (this.data.type === 'create') {
      group.controls['email'].setValidators([Validators.required, Validators.pattern(this.emailPattern)]);
      group.controls['Password'].setValidators([Validators.required, this.checkPass]);
      group.controls['ConfirmPassword'].setValidators([Validators.required]);
    } else {
      group.controls['Password'].setValidators([this.checkPass]);
    }
    group.setValidators([Validators.required, this.checkPasswords]);
    group.controls['phoneNumber'].setValidators([this.checkPhone]);
    if (this.data.type === 'edit') {
      let phoneNumber = group.controls['phoneNumber'].value;
      if (phoneNumber && phoneNumber.length === 12) {
        phoneNumber = phoneNumber.slice(2, 12);
      }
      group.controls['phoneNumber'].setValue(phoneNumber);
    }
    return group;
  }

  checkPhone(control: UntypedFormControl) {
    if (control.value && control.value.length > 0) {
      const res = control.value.match('^[0-9]{10}$');
      if (res === null) {
        return {err: true};
      }
    }
    return null;
  }

  checkPass(control: UntypedFormControl) {
    const value = control.value;
    if (value !== null && value !== undefined && String(value).length > 0) {
      // минимум 6 символов и хотя бы одна цифра
      const pas = /^(?=.*\d).{6,}$/;
      const ok = pas.test(String(value));
      if (!ok) {
        return {passPatt: true};
      }
    }
    return null;
  }

  checkPasswords(group: UntypedFormGroup) {
    const passControl = group.get('Password');
    const confirmControl = group.get('ConfirmPassword');
    const pass = passControl ? passControl.value : null;
    const confirmPass = confirmControl ? confirmControl.value : null;

    // If user is not changing password, keep form valid.
    if (!pass && !confirmPass) {
      if (confirmControl && confirmControl.errors && confirmControl.errors.notSame) {
        const nextErrors = { ...confirmControl.errors };
        delete nextErrors.notSame;
        confirmControl.setErrors(Object.keys(nextErrors).length ? nextErrors : null);
      }
      return null;
    }

    const mismatch = pass !== confirmPass;

    // Put the error on ConfirmPassword too, so mat-error can bind to that control.
    if (confirmControl) {
      const currentErrors = confirmControl.errors || null;
      const hasNotSame = !!(currentErrors && currentErrors.notSame);

      if (mismatch && !hasNotSame) {
        confirmControl.setErrors({ ...(currentErrors || {}), notSame: true });
      }

      if (!mismatch && hasNotSame) {
        const nextErrors = { ...(currentErrors || {}) };
        delete nextErrors.notSame;
        confirmControl.setErrors(Object.keys(nextErrors).length ? nextErrors : null);
      }
    }

    return mismatch ? {notSame: true} : null;
  }

  save() {
    if (this.data.type === 'edit') {
      if (this.dataGroup.valid) {
        this.service.editUser(this.dataGroup.value).subscribe(_ => {
          this.service.setUserRegions(this.dataGroup.value.mioID.join(), this.dataGroup.value.id).subscribe(_ => {
            this.snackBar.open('Пользователь успешно обновлен!', '', {
              duration: 5000,
              verticalPosition: 'top',
              horizontalPosition: 'right',
              panelClass: ['snackbar-succes']
            });
            this.dialogRef.close('cool');
          });
        });
      }
    }
    if (this.data.type === 'create') {
      if (this.dataGroup.valid) {
        this.service.createUser(this.dataGroup.value).subscribe(res => {
          this.service.setUserRegions(this.dataGroup.value.mioID.join(), res).subscribe(_ => {
            this.snackBar.open('Новый пользователь успешно создан!', '', {
              duration: 5000,
              verticalPosition: 'top',
              horizontalPosition: 'right',
              panelClass: ['snackbar-succes']
            });
            this.dialogRef.close('cool');
          }, (err) => {
            if (err instanceof HttpErrorResponse) {
              setTimeout(() => {
                // tslint:disable-next-line:forin
                for (const k in err.error.modelState) {
                  this.snackBar.open(k + ' ' + err.error.modelState[k][0], '', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'right',
                    panelClass: ['snackbar-error']
                  });
                }
              }, 5000);
            }
          });
        });
      }
    }
  }

  compareObjects(o1: any, o2: any) {
    // tslint:disable-next-line:triple-equals
    return o1 == o2;
  }

  compareObjects2(o1: any, o2: any) {
    // tslint:disable-next-line:triple-equals
    return o1 == o2;
  }

  setSelectedCompany(departments: IDepartment[]) {
    this.departments = departments;
    this.departmentSelect.placeholder = 'Подразделение *';
    this.dataGroup.controls['departmentID'].setErrors({'incorrect': true});
  }
}
